var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystalClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 46.591 48.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checklist",
    transform: "translate(-1.619 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21423",
    "data-name": "Group 21423",
    transform: "translate(9.127 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37008",
    "data-name": "Path 37008",
    d: "M37.807,6.249H34.243l-.115-.439a6.023,6.023,0,0,0-4.744-4.356,21.868,21.868,0,0,0-3.63-.354,21.788,21.788,0,0,0-3.588.352,6.026,6.026,0,0,0-4.744,4.354l-.117.442H13.737A7.472,7.472,0,0,0,6.28,13.72V27.542a1.462,1.462,0,0,0,2.924,0V13.72a4.544,4.544,0,0,1,4.531-4.548h3.471A4.363,4.363,0,0,0,21.468,12.4h8.61a4.363,4.363,0,0,0,4.262-3.227h3.468a4.544,4.544,0,0,1,4.53,4.548V38.537a4.535,4.535,0,0,1-4.53,4.531H20.25a1.462,1.462,0,0,0,0,2.924H37.809a7.464,7.464,0,0,0,7.455-7.455V13.72a7.473,7.473,0,0,0-7.457-7.471ZM31.3,8.878a1.527,1.527,0,0,1-1.217.6h-8.61A1.536,1.536,0,0,1,19.985,7.55l.263-.994a3.089,3.089,0,0,1,2.44-2.227,18.789,18.789,0,0,1,3.066-.307,18.854,18.854,0,0,1,3.109.307A3.087,3.087,0,0,1,31.3,6.554l.261.992A1.534,1.534,0,0,1,31.3,8.878Z",
    transform: "translate(-6.28 -1.1)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37009",
    "data-name": "Path 37009",
    d: "M17.3,16.435H28.613a1.462,1.462,0,0,0,0-2.924H17.3a1.462,1.462,0,1,0,0,2.924Z",
    transform: "translate(-0.313 6.647)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37010",
    "data-name": "Path 37010",
    d: "M13.423,16.435h.843a1.462,1.462,0,1,0,0-2.924h-.843a1.462,1.462,0,1,0,0,2.924Z",
    transform: "translate(-2.734 6.647)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37011",
    "data-name": "Path 37011",
    d: "M17.3,20.625H28.613a1.462,1.462,0,0,0,0-2.924H17.3a1.462,1.462,0,0,0,0,2.924Z",
    transform: "translate(-0.313 9.262)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37012",
    "data-name": "Path 37012",
    d: "M15.727,19.164A1.462,1.462,0,0,0,14.266,17.7h-.843a1.462,1.462,0,1,0,0,2.924h.843A1.463,1.463,0,0,0,15.727,19.164Z",
    transform: "translate(-2.734 9.263)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37013",
    "data-name": "Path 37013",
    d: "M10.592,19.975a8.872,8.872,0,1,0,8.873,8.873,8.882,8.882,0,0,0-8.873-8.873Zm0,14.821a5.949,5.949,0,1,1,5.948-5.949A5.954,5.954,0,0,1,10.592,34.8Z",
    transform: "translate(0 11.781)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37014",
    "data-name": "Path 37014",
    d: "M10.314,24.084,7.85,26.069l-.508-.648a1.462,1.462,0,1,0-2.3,1.806L6.465,29.04a1.459,1.459,0,0,0,.984.549,1.376,1.376,0,0,0,.166.01,1.462,1.462,0,0,0,.916-.323l3.617-2.914a1.462,1.462,0,1,0-1.834-2.277Z",
    transform: "translate(1.879 14.144)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalClear);
export default __webpack_public_path__ + "static/media/crystal-clear.580d46dbddbe1b8e64a2e53eecda7fe6.svg";
export { ForwardRef as ReactComponent };